module.exports = __webpack_public_path__ + "img/videoDefualtCover.c8ebb4e9.png";